import React from 'react';
import { Table, Button, Badge } from 'react-bootstrap';
import { DOC_TYPE_META, docTypeLabel } from '../../Utils/billingoDocuments';
import { formatTripWhen } from '../../Utils/bookingContext';
import { DocumentStatus } from './InvoiceStatusPill';
import DocumentTotal from './DocumentTotal';
import useDocumentActions from './useDocumentActions';

// An order's documents, each opening its details, with the send / create
// Számla / cancel actions. Shared by the per-order panel and the Invoicing
// expanded row. `finalBlocked` is why a Számla can't be issued yet ('' when
// it can); `onChanged` runs after anything is issued or cancelled.
function BillingoDocumentList({
  documents, finalBlocked = '', defaultEmail = '', onChanged,
}) {
  const {
    actionsFor, openDetails, alert, modals,
  } = useDocumentActions({
    onChanged, finalBlocked, defaultEmail,
  });

  return (
    <>
      {alert}
      {documents.length > 0 && (
        <Table responsive size="sm" className="align-middle">
          <thead className="table-light">
            <tr>
              <th>Type</th>
              <th>Number</th>
              <th>Issued</th>
              <th className="text-end">Total</th>
              <th>Status</th>
              <th aria-label="pdf" />
            </tr>
          </thead>
          <tbody>
            {documents.map((doc) => (
              <tr key={doc.id}>
                <td>
                  <Badge
                    bg={DOC_TYPE_META[doc.type]?.variant || 'secondary'}
                    text={DOC_TYPE_META[doc.type]?.variant === 'light' ? 'dark' : undefined}
                  >
                    {docTypeLabel(doc.type)}
                  </Badge>
                </td>
                <td>
                  <Button
                    variant="link"
                    className="p-0 text-decoration-none"
                    onClick={() => openDetails(doc)}
                  >
                    {doc.number}
                  </Button>
                </td>
                <td className="text-nowrap">{formatTripWhen(doc.created_at, { withTime: false })}</td>
                <td className="text-end"><DocumentTotal doc={doc} /></td>
                <td><DocumentStatus doc={doc} /></td>
                <td className="text-end text-nowrap">
                  {actionsFor(doc)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {modals}
    </>
  );
}

export default BillingoDocumentList;
